import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { TypedMemo } from '../../../common/types';
import { blockMessages } from './blockMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './SMLBlockList.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SMLBlockInsertGapProps {
  /** The block above the gap. */
  afterUUID: string;
  onAdd: (afterUUID: string) => void;
}

/** The gap between two rows: "+ Add here" shows on hover and on focus (design a2). */
const SMLBlockInsertGapComponent: React.FC<SMLBlockInsertGapProps> = ({ afterUUID, onAdd }) => {
  const intl = useIntl();
  const add = useCallback(() => onAdd(afterUUID), [afterUUID, onAdd]);
  return (
    <div className={styles.gap}>
      <button type="button" className={styles.gapButton} onClick={add} data-testid={`add-here-${afterUUID}`}>
        <FontAwesomeIcon icon={faPlus} />
        {intl.formatMessage(blockMessages.addHere)}
      </button>
    </div>
  );
};

export const SMLBlockInsertGap = TypedMemo(SMLBlockInsertGapComponent);
